<template>


	<div class="mt-4">

		<div class="w-100 account-header">
			<h2 class="mb-none">Contact Information</h2>
			<a class="action" v-if="user.hasPermission" @click.prevent="form = true"><i class="el-icon-edit float-right"></i></a>
			<em v-if="isViewingOwnProfile">Visible To You &amp; Sunstone Only</em>
		</div>
		
		<hr class="solid mt-xs">

		<div class="form-group">
			<div class="row">
				<div class="col-sm-6 col-xl-4">
					<dl>
						<dt>Street</dt>
						<dd>{{user.street}}</dd>
					</dl>
				</div>
				<div class="col-sm-6 col-xl-4">
					<dl>
						<dt>City</dt>
						<dd>{{user.city}}</dd>
					</dl>
				</div>

				<div class="col-sm-6 col-xl-4">
					<dl>
						<dt>State</dt>
						<dd>{{user.state}}</dd>
					</dl>
				</div>
				<div class="col-sm-6 col-xl-4">
					<dl>
						<dt>Zip</dt>
						<dd>{{user.zip}}</dd>
					</dl>
				</div>
				<div class="col-sm-6 col-xl-4">
					<dl>
						<dt>Country</dt>
						<dd>{{user.country}}</dd>
					</dl>
				</div>
				<div class="col-sm-6 col-xl-4">
					<dl>
						<dt>Mobile</dt>
						<dd>{{user.cell}}</dd>
					</dl>
				</div>
				<div class="col-sm-6 col-xl-4">
					<dl>
						<dt>Primary Phone</dt>
						<dd>{{user.telephone}}</dd>
					</dl>
				</div>
				<div class="col-sm-6 col-xl-4">
					<dl>
						<dt>DOB</dt>
						<dd>{{user.dob}}</dd>
					</dl>
				</div>
				<div class="col-sm-6 col-xl-4">
					<dl>
						<dt>Gender</dt>
						<dd>{{user.gender}}</dd>
					</dl>
				</div>
				<div class="col-sm-6 col-xl-4">
					<dl>
						<dt>Referral Source</dt>
						<dd>{{user.referralSource}}</dd>
					</dl>
				</div>
				<div class="col-sm-6 col-xl-4">
					<dl>
						<dt>Survey Preference</dt>
						<dd>{{user.surveyPreference}}</dd>
					</dl>
				</div>
			</div>
		</div>


		<el-dialog title="Contact Information"
							 :visible.sync="form"
							 :width="modalWidth"
							 :close-on-click-modal="false"
							 :append-to-body="false">

			<div class="form row">

				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('country')}]">
					<label>Country*</label>
					<el-select v-model="data.countryId" filterable clearable name="country" data-vv-as="country" data-vv-validate-on="change" class="w-100" v-validate="'required'" placeholder="Select">
						<el-option value="221" label="United States"></el-option>
						<el-option :key="country.entryId" v-for="country in datasource.countries" :value="String(country.entryId)" :label="country.text" />
					</el-select>
					<span v-if="errors.has('country')">{{errors.first('country')}}</span>
				</div>

				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('street')}]">
					<label>Street*</label>
					<el-input v-model="data.street" name="street" data-vv-as="street" class="w-100" v-validate="'required'" />
					<span v-if="errors.has('street')">{{errors.first('street')}}</span>
				</div>

				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('city')}]">
					<label>City*</label>
					<el-input v-model="data.city" name="city" data-vv-as="city" class="w-100" v-validate="'required'" />
					<span v-if="errors.has('city')">{{errors.first('city')}}</span>
				</div>


			</div>

			<div class="form row">

				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('state')}]">
					<label>State <span v-if="datasource.regions.length > 0">*</span></label>
					<el-select :disabled="!data.countryId" v-loading="thinking.regions" v-model="data.stateId" filterable clearable name="state" data-vv-validate-on="change" data-vv-as="state" class="w-100" v-validate="{ required: datasource.regions.length > 0}" placeholder="Select">
						<el-option :key="state.entryId" v-for="state in datasource.regions" :value="String(state.entryId)" :label="state.text" />
					</el-select>
					<span v-if="errors.has('state')">{{errors.first('state')}}</span>
				</div>

				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('zip')}]">
					<label>Zip*</label>
					<el-input v-model="data.zip" name="zip" data-vv-as="zip" class="w-100" v-validate="'required'" />
					<span v-if="errors.has('zip')">{{errors.first('zip')}}</span>
				</div>

				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('cell')}]">
					<label>Mobile*</label>
					<el-input v-model="data.cell" name="cell" data-vv-as="cell" class="w-100" v-validate="'required'" />
					<span v-if="errors.has('cell')">{{errors.first('cell')}}</span>
				</div>


			</div>

			<div class="form row">

				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('primary phone')}]">
					<label>Primary Phone</label>
					<el-input v-model="data.telephone" name="primary phone" data-vv-as="primary phone" class="w-100" />
					<span v-if="errors.has('primary phone')">{{errors.first('primary phone')}}</span>
				</div>

				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('date of birth')}]">
					<label>Date of Birth*</label>
					<el-date-picker v-model="data.dob"
													v-validate="'required'"
													type="date"
													format="MM/dd/yyyy"
													value-format="MM/dd/yyyy"
													name="date of birth"
													class="w-100"
													data-vv-as="date of birth"
													placeholder="Pick a day">
					</el-date-picker>

					<span v-if="errors.has('date of birth')">{{errors.first('date of birth')}}</span>
				</div>

				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('gender')}]">
					<label>Gender*</label>
					<el-select v-model="data.gender" clearable name="gender" data-vv-as="gender" class="w-100" data-vv-validate-on="change" v-validate="'required'" placeholder="Select">
						<el-option value="F" label="Female" />
						<el-option value="M" label="Male" />
					</el-select>
					<span v-if="errors.has('gender')">{{errors.first('gender')}}</span>
				</div>

			</div>

			<div class="form row">

				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('referral source')}]">
					<label>Referral Source*</label>
					<el-select v-loading="thinking.referralSources" data-vv-validate-on="change" v-model="data.referralSourceId" filterable clearable name="referral source" data-vv-as="referral source" class="w-100" v-validate="'required'" placeholder="Select">
						<el-option :key="r.entryId" v-for="r in datasource.referralSources" :value="String(r.value)" :label="r.text" />
					</el-select>
					<span v-if="errors.has('referral source')">{{errors.first('referral source')}}</span>
				</div>

				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('email preference')}]">
					<label>Email Preference</label>
					<el-select v-loading="thinking.surveySources" data-vv-validate-on="change" v-model="data.surveyPreferenceId" filterable clearable name="email preference" data-vv-as="email preference" class="w-100" v-validate="'required'" placeholder="Select">
						<el-option :key="r.entryId" v-for="r in datasource.surveySources" :value="String(r.value)" :label="r.text" />
					</el-select>
					<span v-if="errors.has('survey source')">{{errors.first('survey source')}}</span>
				</div>
			</div>


			<span slot="footer" class="dialog-footer">
				<el-button :disabled="thinking.save" @click="form = false">Cancel</el-button>
				<el-button :loading="thinking.save" type="primary" @click="submit">Confirm</el-button>
			</span>
		</el-dialog>
	</div>
	 	
</template>

<script>
	import { rest } from "@/utilities/rest.js";
	import { mapGetters } from "vuex";
	export default {
		name: "contact-info",
		data() {
			return {
				view: "template",
				form: false,
				data: {
					countryId: null,
					cell: null
				},

				datasource: {
					countries: [],
					regions: [],
					referralSources: [],
					surveySources: []
				},

				thinking: {
					save: false,
					countries: false,
					regions: false,
					referralSources: false,
					surveySources: false
				}
			}
		},

		created() {
			this.data = JSON.parse(JSON.stringify(this.user));
			
		},

		computed: {
			...mapGetters({
				modalWidth: "modalWidth"
			})
		},

		methods: {

			fetch() {
				rest.get("Account", "/GetDataSources", "json", {
					countryId: this.data.countryId
				}).done(response => {
					this.datasource.countries = response.countries;
					this.datasource.regions = response.regions;
					this.datasource.referralSources = response.referralSources;
					this.datasource.surveySources = response.surveySources;
					
				}).always(() => {
					this.thinking.countries = false;
					this.thinking.regions = false;
					this.thinking.referralSources = false;
					this.thinking.surveySources = false;
				});
			},

			fetchRegions() {
				this.thinking.regions = true;
				rest.get("Account", "/GetRegions", "json", {
					countryId: this.data.countryId
				}).done(response => {
					this.datasource.regions = response;					
				}).always(() => {
					this.thinking.regions = false;
				})
			},

			submit() {
				this.$validator.validateAll().then(valid => {
					if (valid) {
						this.thinking.save = true;
						rest.post("Account", "/UpdateContactInfo", "json", JSON.stringify(this.data)).done(response => {
							setTimeout(() => {
								this.$message.success("Changes have been saved.");
							}, 1000);
							this.form = false;
							this.$emit("fetch", "contactInfo");

						}).fail((error) => {

						}).always(() => {
							this.thinking.save = false;
						})
					}
				});
			}
		},

		props: ["user", "isViewingOwnProfile"],

		watch: {
			'data.countryId': function (old, val) {
				if (this.form) {
					this.data.stateId = null;
					this.datasource.regions = [];
					this.fetchRegions();
				}
				
			},
			'data.cell': function (val) {
				if (val && val.length) {
					var x = val.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
					this.data.cell = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
				}				
			},
			form(val) {
				if (val) {
					this.$validator.reset();
					this.thinking.countries = false;
					this.thinking.regions = false;
					this.thinking.referralSources = false;
					this.thinking.surveySources = false;
					this.data = JSON.parse(JSON.stringify(this.user));
					this.fetch();
					
				}
			}
		}
	}
</script>